enum TEN_PHONG {
  khuc_xa = "Phòng khám khúc xạ",
  dieu_duong = "Phòng điều dưỡng",
  noi_tru = "Phòng nội trú",
  phau_thuat = "Phòng phẫu thuật",
  xet_nghiem = "Phòng xét nghiệm",
  thanh_toan = "Phòng thanh toán",
  kham_ngoai_tru = "Phòng khám",
  tiep_nhan = "",
  phong_chup_mi_mat = "Phòng chụp đáy mắt",
  
}
export { TEN_PHONG };
